(function ($) {
    'use strict'

    if (window.location.href.indexOf("my-account/subscriptions") === -1) {
        // only run this on the appropriate page
        return;
    }

    $(window).load(function () {

        // FORM FIELDS
        const retentionAppIdField = document.querySelector('input[name=chargebee_retention_app_id]');




        // enable subscription management buttons now that page load has completed
        $('.button-subscription-management').removeAttr("disabled")
        if (retentionAppIdField) {
            // set the app ID on the retention object
            window.subscriptions.retention.setAppId(retentionAppIdField.value);
        }

        // allows packages to be changed within a subscription
        $(".choose-plan-button").click(async function () {
            let popup = document.querySelector('.package-change-popup');
            let subscriptionId = this.dataset.subscriptionId;
            let planId = this.dataset.planId;
            let addonId = this.dataset.addonId;

            window.utils.forms.removeErrorMessage(popup);
            window.utils.animations.addLoadingSpinner(document.querySelector('body'))

            const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${subscriptionId}/upgrade`, {
                plan_id: planId,
                addon_id: addonId,
            })

            let responseObj = JSON.parse(responseJson)
            if (responseObj.success) {
                location.reload()
            } else {
                console.error(responseObj);
                window.utils.forms.addErrorMessage('Could not switch subscription, please try again or contact dermteam@klira.skin', popup);
                window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
            }
        })

        $(".button-reactivate-subscription").click(async function () {
            const subId = $(this).data("subscription-id")
            window.utils.animations.addLoadingSpinner(document.querySelector('body'))
            const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${subId}/reactivate`)

            let responseObj = JSON.parse(responseJson)
            if (responseObj.success) {
                location.reload()
            } else {
                console.error(responseObj);
                window.utils.forms.addErrorMessage('Could not reactivate subscription, please try again or contact dermteam@klira.skin', this);
                window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
            }
        })






        // EVENT LISTENERS

        // Skip a month - modal open
        document.addEventListener(
            'click',
            function(event) {
                if (!event.target.matches('.skip-a-month-button')) {
                    return;
                }

                console.log("SUBSCRIPTION: Opened skip a month popup");

                let subscriptionId = event.target.dataset.subscriptionId;
                let nextOrderDate = event.target.dataset.nextOrderDate;
                let newOrderDate = event.target.dataset.newOrderDate;

                const skipAMonthPopup = document.querySelector('.skip-a-month-popup');
                const nextOrderDateEle = skipAMonthPopup.querySelector('.next-order-date');
                const newOrderDateEle = skipAMonthPopup.querySelector('.new-order-date');
                nextOrderDateEle.innerHTML = nextOrderDate;
                newOrderDateEle.innerHTML = newOrderDate;

                if (!subscriptionId) {
                    console.error("SUBSCRIPTION: No subscription ID could be found");
                    return;
                }

                // set the subscription ID
                window.subscriptions.setSubscriptionId(subscriptionId);
            }
        )

        // Skip a month - confirm click
        document.addEventListener(
            'click',
            async function(event) {
                if (!event.target.matches('.confirm-skip-a-month-button')) {
                    return;
                }

                window.utils.forms.removeErrorMessage(event.target);

                window.utils.animations.addLoadingSpinner(document.querySelector('body'));

                let response = await window.subscriptions.skipAMonth.skip()

                if (response.success) {
                    window.location.href = "/my-account/subscriptions/"
                } else {
                    console.log(response);
                    window.utils.forms.addErrorMessage(response.message, event.target);
                    window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
                }
            }
        )

        // Subscription - Cancel (launches retention flow)
        document.addEventListener(
            'click',
            function(event) {
                if (!event.target.matches('.subscription-cancellation-button')) {
                    return;
                }

                let button = event.target;

                const addonId = button.dataset.addonId;
                // const subscriptionId = button.dataset.subscriptionId;
                const cbSubscriptionId = button.dataset.cbSubscriptionId;

                window.subscriptions.retention.setAddonId(addonId);
                window.subscriptions.retention.setCbSubscriptionId(cbSubscriptionId);
                window.subscriptions.retention.run().then((response) => {
                    if (response.valid) {
                        window.location.href = response.url;
                    } else {
                        console.error("Error launching retention process", response);
                    }
                });
            }
        );




        // FUNCTIONS
    })
})(jQuery)